﻿export class PersonaDisplayNameSummaryDto {
  public personaId: string;
  public personaDisplayName: string;

  constructor(personaId: string, personaDisplayName: string) {
    this.personaId = personaId;
    this.personaDisplayName = personaDisplayName;
  }
}